import { initDevice } from './modules/devicesHandler.js';
import { padLeft } from './modules/common.js';
import { FooterNav } from './modules/components.js';
import './modules/rydertime.js';


initDevice();


// 手機動畫
// function welcomeAnimation() {
// 	// 檢查是手機版
// 	if (window.innerWidth > 1024) {
// 		return; // 桌面版不執行
// 	}

// 	const $animation = $("#welcomeAnimation");
// 	const $logo = $("#welcomeLogo");
// 	const $imageWrap = $("#welcomeImageWrap");
// 	const $topmenu = $("#topmenuWrap");
// 	const $bannerSection = $("section").first();

// 	//隱藏元素（使用 GSAP 而不是 jQuery CSS）
// 	gsap.set($topmenu, { opacity: 0 });
// 	gsap.set($bannerSection, { opacity: 0 });

// 	// 標記進場動畫正在播放
// 	window.welcomeAnimationPlaying = true;

// 	// GSAP Timeline
// 	const tl = gsap.timeline({
// 		onComplete: function() {
// 			$animation.addClass("is-hidden");
// 			sessionStorage.setItem('welcomeAnimationPlayed', 'true');
// 			// 標記進場動畫已完成
// 			window.welcomeAnimationPlaying = false;
// 		}
// 	});

// 	//初始
// 	tl.set($imageWrap, { scale: 0.7 })
// 	  .set($logo, { opacity: 1 })
// 	  .set($topmenu, { opacity: 0 })
// 	  .set($bannerSection, { opacity: 0 })

// 	// 圖片放大（3.5秒）
// 	  .to($imageWrap, {
// 			scale: 1.33,
// 			duration: 3.5,
// 			ease: "power1.inOut"
// 		}, "+=0.5")

// 	//logo 淡出（1.5秒，與圖片放大同時開始）
// 	  .to($logo, {
// 			opacity: 0,
// 			duration: 1.5,
// 			ease: "power1.out"
// 		}, "0.5")

// 	//淡入 menu（1.5秒，在圖片放大到一半時開始）
// 	  .to($topmenu, {
// 			opacity: 1,
// 			duration: 1.5,
// 			ease: "power1.inOut",
// 			clearProps: "all"
// 		}, "2.25")

// 	//淡入輪播區（1.5秒，與 menu 同時開始）
// 	  .to($bannerSection, {
// 			opacity: 1,
// 			duration: 1.5,
// 			ease: "power1.inOut",
// 			clearProps: "all",
// 			onComplete: function() {
// 				// 確保輪播第一張的狀態正確
// 				const $firstSlide = $("#bannerList").children().eq(0);
// 				gsap.set($firstSlide, {
// 					'clip-path': 'inset(0%)',
// 					zIndex: 4,
// 				});
// 				gsap.set($firstSlide.find(".article-area"), {
// 					opacity: 1,
// 				});
// 				gsap.set($firstSlide.find(".pic"), {
// 					scale: 1,
// 				});
// 			}
// 		}, "2.25")

// 	// 最後淡出整個動畫
// 	  .to($animation, {
// 			opacity: 0,
// 			duration: 0.6,
// 			ease: "power1.out"
// 		}, "+=0.8");
// }

// // 頁面載入後執行
// $(document).ready(function() {
// 	welcomeAnimation();
// });


$("#preload").delay(500).fadeOut(500)


// 選單下滑隱藏 快滾回去時消失
var _scrollLast = 0

$(window).on("scroll", () => {
	var _scrollTop = $(window).scrollTop()
	var _allBottom = $("body").height() - $(window).height() - 100

	if (_scrollTop < 0 || _scrollTop > _allBottom) {
		return false;
	}

	if (_scrollTop > 200) {
		if (_scrollTop > _scrollLast) {
			$("#fixed-header").removeClass("is-show")
		} else {
			$("#fixed-header").addClass("is-show")
		}
	} else {
		$("#fixed-header").removeClass("is-show")
	}

	_scrollLast = _scrollTop
}).trigger("scroll")




let $topmenutl = gsap.timeline({
	paused: true,
})


function topmenuHandler(el) {
	new SplitText($(".ch", el), {
		type: "chars",
		charsClass: "char",
	})

	new SplitText($(".en", el), {
		type: "chars",
		charsClass: "char",
	})


	$(el).children().each(function(i, item) {
		let $ch = $(".ch .char", item)
		let $en = $(".en .char", item)

		$topmenutl.from($ch, {
			duration: 0.5,
			opacity: 0,
			x: 26,
			stagger: {
				amount: 0.3,
			},
		}, 0).from($en, {
			duration: 0.5,
			opacity: 0,
			x: 26,
			stagger: {
				amount: 0.3,
			},
		}, 0)
	})
}





function menuopen() {
	$("#topmenuWrap").addClass("is-show")
	$("#menuOverlay").removeClass("pointer-events-none").addClass("opacity-100")

	$topmenutl.play(0)

	gsap.to(".breathing", {
		scale: 1.3,
		opacity: 0.7,
		duration: 2.2,
		repeat: -1,
		yoyo: true,
		ease: "sine.inOut",
		transformOrigin: "center center"
	})
}


function menuclose() {
	$("#topmenuWrap").removeClass("is-show")
	$("#menuOverlay").addClass("pointer-events-none").removeClass("opacity-100")
}





$(".ryder-split").each(function(i, el) {
	let $split = new SplitText(el, {
		type: "words, chars",
		wordsClass: "word",
		charsClass: "char",
	})
})




$(window).on("load", function() {
	// 首頁優勢區塊的 faq-icon 呼吸動畫
	gsap.fromTo(".adv-breathing",
		{
			scale: 0.7,
			opacity: 0.7
		},
		{
			scale: 1.1,
			opacity: 1,
			duration: 2.5,
			repeat: -1,
			yoyo: true,
			ease: "sine.inOut",
			transformOrigin: "center center"
		}
	)

	$("[data-enter]").each((i, el) => {
		let customOffset = $(el).data('enter') || 0.3;

		let ob_offset = $(window).height() * -customOffset;

		let observer = new IntersectionObserver(function(entries, observer) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-enter');
				} else {
					if (!$(entry.target).hasClass('enter-once')) {
						entry.target.classList.remove('is-enter');
					}
				}
			});
		}, {
			root: null,
			rootMargin: `0px 0px ${ob_offset}px 0px`,
			threshold: 0
		});

		observer.observe(el);
	});
})




// 批量掛載到 window
const globals = {
	padLeft,
	FooterNav,
	menuopen,
	menuclose,
	topmenuHandler,
};

Object.assign(window, globals);